export default __webpack_public_path__ + "static/media/simProfile-1.56fb725a.png";